import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";
import Storage from "../services/Storage";

/** FETCH **/
function* fetchCommunicationMessages(action) {
  try {

    const user = Storage.getItem('user');
    const isNsc = user.role === 'NSC_ADMIN';
    const url = isNsc ? '/nsc/messages' : '/dealer/messages'

    const response = yield call(() => Api.get(url));
    yield put({type: 'FETCH.COMMUNICATION_MESSAGES.SUCCESS', response})
  } catch (error) {
    yield put({type: 'FETCH.COMMUNICATION_MESSAGES.FAILURE', error})
  }
}

export function* watchFetchCommunicationMessages() {
  yield takeEvery('FETCH.COMMUNICATION_MESSAGES.REQUEST', fetchCommunicationMessages);
}

function* fetchCommunicationBackground(action) {
  try {
    const response = yield call(() => Api.get('/nsc/background'));
    yield put({type: 'FETCH.COMMUNICATION_BACKGROUND.SUCCESS', response})
  } catch (error) {
    yield put({type: 'FETCH.COMMUNICATION_BACKGROUND.FAILURE', error})
  }
}

export function* watchFetchCommunicationBackground() {
  yield takeEvery('FETCH.COMMUNICATION_BACKGROUND.REQUEST', fetchCommunicationBackground);
}

function* fetchCommunicationBanners(action) {
  try {
    const response = yield call(() => Api.get('/nsc/banners'));
    yield put({type: 'FETCH.COMMUNICATION_BANNERS.SUCCESS', response})
  } catch (error) {
    yield put({type: 'FETCH.COMMUNICATION_BANNERS.FAILURE', error})
  }
}

export function* watchFetchCommunicationBanners() {
  yield takeEvery('FETCH.COMMUNICATION_BANNERS.REQUEST', fetchCommunicationBanners);
}

/** UPDATE **/
function* updateCommunicationMessages(action) {
  try {
    const user = Storage.getItem('user');
    const isNsc = user.role === 'NSC_ADMIN';
    const url = isNsc ? '/nsc/messages' : '/dealer/messages'
    const response = yield call(() => Api.post(url, {messages:action.body}));
    yield put({type: 'SAVE.COMMUNICATION_MESSAGES.SUCCESS', response});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    yield put({type: 'SAVE.COMMUNICATION_MESSAGES.FAILURE', error})
  }
}

export function* watchUpdateCommunicationMessages() {
  yield takeEvery('SAVE.COMMUNICATION_MESSAGES.REQUEST', updateCommunicationMessages);
}

function* updateCommunicationBackground(action) {
  try {
    const response = yield call(() => Api.post('/nsc/background', action.body));
    yield put({type: 'SAVE.COMMUNICATION_BACKGROUND.SUCCESS', response});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    yield put({type: 'SAVE.COMMUNICATION_BACKGROUND.FAILURE', error})
  }
}

export function* watchUpdateCommunicationBackground() {
  yield takeEvery('SAVE.COMMUNICATION_BACKGROUND.REQUEST', updateCommunicationBackground);
}

function* updateCommunicationBanners(action) {
  try {
    const response = yield call(() => Api.post('/nsc/banners', {banners:action.body}));
    yield put({type: 'SAVE.COMMUNICATION_BANNERS.SUCCESS', response});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
  } catch (error) {
    yield put({type: 'SAVE.COMMUNICATION_BANNERS.FAILURE', error})
  }
}

export function* watchUpdateCommunicationBanners() {
  yield takeEvery('SAVE.COMMUNICATION_BANNERS.REQUEST', updateCommunicationBanners);
}



// WEBPACK FOOTER //
// ./src/sagas/communication.js